import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';

import {
    ChipComponent,
    EMPTY_LINK,
    IChip,
    ILink,
    ImageData,
    ImageItemComponent,
    LinkDirective,
    MediaImage,
} from '@sirius/common';

@Component({
    selector: 'ur-product-card',
    imports: [ChipComponent, ImageItemComponent, LinkDirective],
    templateUrl: './product-card.component.html',
    styleUrl: './product-card.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    host: { class: 'sir-text-style-paragraph-m-default' },
})
export class ProductCardComponent {
    imageData?: ImageData;

    readonly title = input('');
    readonly brandName = input('');
    readonly teaserHtml = input('');
    readonly image = input<MediaImage | undefined>();
    readonly link = input<ILink>(EMPTY_LINK);
    readonly tags = input<IChip[]>([]);
    readonly manufacturer = input<string | undefined>();
    readonly attributes = input<IChip[]>([]);

    readonly clicked = output<void>();

    onClick(): void {
        this.clicked.emit();
    }
}
